import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { CurrencyPipe } from '@angular/common';

const PADDING = '000000';

@Pipe({ name: 'NAN' })
export class NotaNumber implements PipeTransform {
  transform(value:  string) {
    if (value == undefined || value == null || value == '' ||  isNaN(Number(value))) {
      return new DecimalPipe('en').transform(0, '1.2-2');
    }else{ return value; }
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/_pipe/NotANumber.ts